import React, { useState, useRef, useEffect } from "react";
import { clearCart } from "../../../../store/cartSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Topbar } from "../../../../Components/Header/Header";
import { Container, Row } from "react-bootstrap";
import HeaderToolbar from "../../../../Components/Header/HeaderToolbar";
import { useTranslation } from "react-i18next";
import { FiMoon, FiSun } from "react-icons/fi";
import CartIcon from "../../../../Components/Header/CartIcon";
import CartDrawer from "../../product/CartDrawer";

const DEFAULT_FONT_SIZE = 16;

const MemberHeader = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const [customer, setCustomer] = useState(null);
  const [showCart, setShowCart] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();

  const [lang, setLang] = useState("gu");
  const [fontSize, setFontSize] = useState(DEFAULT_FONT_SIZE);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const ADMIN_WEB = process.env.REACT_APP_WEB_URL;

  // Load saved language from localStorage and apply to html tag
  useEffect(() => {
    const savedLang = localStorage.getItem("lang") || "gu";
    setLang(savedLang);
    i18n.changeLanguage(savedLang);
    document.documentElement.lang = savedLang;
  }, [i18n]);

  const handleLanguageChange = (e) => {
    const selectedLang = e.target.value;
    setLang(selectedLang);
    i18n.changeLanguage(selectedLang);
    localStorage.setItem("lang", selectedLang);
    document.documentElement.lang = selectedLang;
  };

  useEffect(() => {
    document.documentElement.style.fontSize = `${fontSize}px`;

    if (isDarkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }

    const contrastWarningId = "contrast-warning";
    const existing = document.getElementById(contrastWarningId);
    if (existing) existing.remove();

    if (isDarkMode) {
      const color = window.getComputedStyle(document.body).color;
      const rgb = color.match(/\d+/g)?.map(Number);
      const isLowContrast = rgb && rgb.every((v) => v > 150);

      if (isLowContrast) {
        const warning = document.createElement("div");
        warning.id = contrastWarningId;
        warning.textContent =
          "⚠️ Text color is too light for dark background. Adjust for readability.";
        warning.style.color = "#ff0000";
        warning.style.background = "#fff";
        warning.style.padding = "5px 10px";
        warning.style.textAlign = "center";
        document.body.prepend(warning);
      }
    }

    return () => {
      const warn = document.getElementById(contrastWarningId);
      if (warn) warn.remove();
    };
  }, [isDarkMode, fontSize]);

  const toggleDarkMode = () => setIsDarkMode((prev) => !prev);
  // -------------------------here from header func ----------------------
  useEffect(() => {
    const session = localStorage.getItem("customer"); // ✅ sessionStorage
    setCustomer(session ? JSON.parse(session) : null);
  }, []);

  // close popup on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ------------------------------------
  const handleOpenMemberSite = () => {
    window.open(`${ADMIN_WEB}`, "_blank");
  };

  const onLogout = () => {
    // setShowModal(false);
    localStorage.removeItem("customer");
    // localStorage.removeItem("checkoutAddress");
    // Clear Redux cart
    dispatch(clearCart());
    // (Optional) clear cookies if you add them later
    // document.cookie = "token=; Max-Age=0; path=/;";
    // navigate("/", { replace: true });
    handleOpenMemberSite();
    console.log("User logged out");
  };

  return (
    <>
      <header
        className="d-flex justify-content-between align-items-center px-3 py-0 border-bottom shadow-sm"
        style={{ backgroundColor: "#FF4F00" }}
      >
        {/* LEFT - Logo */}
        <div className="d-flex align-items-center gap-2 cursor-pointer">
          <img
            src="/assets/logo/barejadham.png"
            alt="Bareja Dham"
            style={{ width: "60px", height: "60px", objectFit: "cover" }}
            // className="m-1"
          />
        </div>

        {/* RIGHT SIDE (Toolbar + Profile) */}
        <div
          className="d-flex align-items-center gap-3 position-relative"
          ref={menuRef}
        >
          {/* 1️⃣ Font Controls */}
          {/* <div className="d-flex align-items-center gap-1 bg-white rounded-pill px-2 py-1"> */}
          {/* 1️⃣ Font Controls (HIDDEN ON MOBILE) */}
          <div className="d-none d-md-flex align-items-center px-2 mb-1">
            <div className="d-flex align-items-center gap-2">
              <button
                onClick={() => setFontSize((s) => Math.max(s - 1, 12))}
                className="px-2 py-1 border bg-[#FFf]  hover:bg-[#FF4F00] text-[#FF4F00] hover:text-[#FFf] rounded-full"
                title="Decrease Font"
              >
                A−
              </button>
              <button
                onClick={() => setFontSize(DEFAULT_FONT_SIZE)}
                className="px-2 py-1 border bg-[#FFf]  hover:bg-[#FF4F00] text-[#FF4F00] hover:text-[#FFf] rounded-full"
                title="Reset Font"
              >
                A
              </button>
              <button
                onClick={() => setFontSize((s) => s + 1)}
                className="px-2 py-1 border bg-[#FFf]  hover:bg-[#FF4F00] text-[#FF4F00] hover:text-[#FFf] rounded-full"
                title="Increase Font"
              >
                A+
              </button>
            </div>
          </div>

          {/* 2️⃣ Dark / Light Mode Toggle */}
          <button
            onClick={toggleDarkMode}
            className="d-flex align-items-center bg-[#FFf] border rounded-circle p-2 border-0"
            title={isDarkMode ? "Switch to Light" : "Switch to Dark"}
          >
            {isDarkMode ? (
              <FiSun size={18} className="text-[#FF4F00]" />
            ) : (
              <FiMoon size={18} className="text-[#FF4F00]" />
            )}
          </button>

          {/* 3️⃣ Language Dropdown */}
          <select
            id="lang-switch"
            value={lang}
            onChange={handleLanguageChange}
            className="text-dark bg-white border rounded px-1 py-1 small"
            style={{ width: "75px" }}
          >
            <option value="en">English</option>
            <option value="hi">हिंदी</option>
            <option value="gu">ગુજરાતી</option>
          </select>

          <CartIcon onClick={() => setShowCart(true)} />
          <CartDrawer show={showCart} onHide={() => setShowCart(false)} />
          {/* Divider */}
          {/* <div
            className="border-start border-light mx-1"
            style={{ height: "35px" }}
          ></div> */}

          {/* Profile Welcome + Avatar */}
          <span className="text-dark  d-none d-md-inline">
            Welcome to{" "}
            <span className="text-white">&nbsp;{customer?.memberName}</span>
          </span>

          <img
            src={"/assets/logo/300-16.jpg"}
            alt="Member"
            className="cursor-pointer rounded-circle border shadow-sm"
            style={{ width: 42, height: 42, objectFit: "cover" }}
            onClick={() => setOpen(!open)}
          />

          {/* Dropdown */}
          {open && (
            <div
              className="position-absolute bg-white shadow-lg rounded py-2"
              style={{
                top: "105%",
                right: 0,
                minWidth: "170px",
                zIndex: 999,
              }}
            >
              <p className="mb-1 fw-semibold text-dark px-3 d-flex align-items-center gap-2">
                <img
                  src={"/assets/logo/300-16.jpg"}
                  alt="Member"
                  className="cursor-pointer rounded-circle border shadow-sm"
                  style={{ width: 42, height: 42, objectFit: "cover" }}
                  onClick={() => setOpen(!open)}
                />
                <span className="text-dark">{customer?.memberName}</span>
              </p>

              <hr className="my-2" />

              <button
                className="dropdown-item text-dark px-3 py-1"
                onClick={() => navigate("/my-profile")}
              >
                My Profile
              </button>
              <button
                className="dropdown-item text-danger px-3 py-1"
                onClick={onLogout}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default MemberHeader;
